import React from 'react';
import { Navbar, Button, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';

const Layout = ({ children }) => {
  const navigate = useNavigate();

  // Handle Logout
  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        alert('You have been logged out.');
        navigate('/');
      })
      .catch((error) => {
        console.error('Logout Error:', error);
      });
  };

  return (
    <div>
      {/* Persistent Navbar */}
      <Navbar bg="warning" variant="dark" sticky="top">
        <Container>
          <Navbar.Brand>Fintorro</Navbar.Brand>
          <Button variant="dark" onClick={handleLogout} className="ms-auto">
            Logout
          </Button>
        </Container>
      </Navbar>

      {/* Render Child Components */}
      <div style={{ paddingTop: '56px' }}>{children}</div> {/* Adjust padding to avoid overlap */}
    </div>
  );
};

export default Layout;
